import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    to: {
      label: {
        id: 'properties.to',
        defaultMessage: 'To',
        description: 'label of the form field to',
      },
    },
    cc: {
      label: {
        id: 'properties.cc',
        defaultMessage: 'Cc',
        description: 'label of the form field cc',
      },
    },
    bcc: {
      label: {
        id: 'properties.bcc',
        defaultMessage: 'Bcc',
        description: 'label of the form field bcc',
      },
    },
    subject: {
      label: {
        id: 'properties.subject',
        defaultMessage: 'Subject',
        description: 'label of the form field subject',
      },
    },
    content: {
      label: {
        id: 'properties.content',
        defaultMessage: 'Content',
        description: 'label of the form field content',
      },
    },
  },
  formActions: {
    cancel: {
      id: 'formActions.cancel',
      defaultMessage: 'Cancel',
      description: 'label of the form action cancel button',
    },
    send: {
      id: 'formActions.send',
      defaultMessage: 'Send',
      description: 'label of the form action send button',
    },
  },
};

export default defineMessages(translations);
